import { type Action, FilterActionTypes, action } from "easy-peasy";

import DEFAULT_SORT from "./default";
import { type SortOption } from "./options";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logEffect = (property: keyof FilterActionTypes<SortModel>) =>
  createLogEffect<SortModel>("SORT", property, false);

export type SortModel = {
  value: SortOption;
  valueOnChange: LogEffect<SortModel>;
  set: Action<SortModel, SortOption>;
};

const sortModel: SortModel = {
  value: DEFAULT_SORT,
  valueOnChange: logEffect("value"),
  set: action((state, payload) => {
    state.value = payload;
  }),
};

export default sortModel;
